/**
 * BarrierProfile
 */
export class BarrierProfile {
  /**
   * profile Id
   */
  profileId: string;

  /**
   * name
   */
  name: string;

  /**
   * max vehicles
   */
  maxVehicles: number;

  /**
   * max persons
   */
  maxPersons: number;
  /**
   * Create instance from JSON
   *
   * @param json Object
   *
   * @returns TypeVehicle instance
   */
  static createFromJson(json: object): BarrierProfile {
    const self = new this();

    Object.keys(json).forEach(key => {
      self[key] = json[key];
    });

    return self;
  }

}
